<template>
  <v-app>
    <div class="text-right"
         style="direction: rtl">
      <router-view></router-view>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  },

  data: () => ({
    //
  }),
};
</script>
